import RMPartList from "./RMPartList";

export default RMPartList;
